import { render, staticRenderFns } from "./LiveShowcase.vue?vue&type=template&id=5fdd0c57&scoped=true&"
import script from "./LiveShowcase.vue?vue&type=script&lang=js&"
export * from "./LiveShowcase.vue?vue&type=script&lang=js&"
import style0 from "./LiveShowcase.vue?vue&type=style&index=0&id=5fdd0c57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd0c57",
  null
  
)

export default component.exports